import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export type LazyComponentWithPreload<T extends ComponentType<any>> = {
  preload: () => Promise<{ default: T }>;
} & LazyExoticComponent<T>;

const lazyWithPreload = (
  factory: () => Promise<{ default: ComponentType<any> }>,
): LazyComponentWithPreload<ComponentType<any>> => {
  const Component = lazy(factory) as LazyComponentWithPreload<ComponentType<any>>;
  Component.preload = factory;
  return Component;
};

export const Welcome = lazyWithPreload(() => import('../../pages/Welcome'));
export const Lp1Welcome = lazyWithPreload(() => import('../../pages/Welcome/Lp1Welcome'));
export const ComboWelcome = lazyWithPreload(() => import('../../pages/WinCombo/ComboWelcome'));
export const OnePagerAll5Gnhdl = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all5_gnhdl'),
);
export const OnePagerAll5Kwtt = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all5_kwtt'),
);
export const OnePagerAll5Fr = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all5_fr'),
);
export const OnePagerAll5Dc = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all5_dc'),
);
export const OnePagerAllWs = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_all_ws'),
);
export const OnePagerPrntLg = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboWelcome/one_pager_prnt_lg'),
);
export const Map = lazyWithPreload(() => import('../../pages/Map'));
export const Signup = lazyWithPreload(() => import('../../pages/Signup'));
export const EmailConsent = lazyWithPreload(() => import('../../pages/EmailConsent'));
export const Features = lazyWithPreload(() => import('../../pages/Features'));
export const Checkout = lazyWithPreload(() => import('../../pages/Checkout'));
export const Upsell = lazyWithPreload(() => import('../../pages/Upsell'));
export const UpsellGuide = lazyWithPreload(() => import('../../pages/UpsellGuide'));
export const ComboMap = lazyWithPreload(() => import('../../pages/WinCombo/ComboMap'));
export const ComboMapAnimated = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboMapAnimated'),
);
export const ComboSignup = lazyWithPreload(() => import('../../pages/WinCombo/ComboSignup'));
export const ComboSignupPrntLg = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboSignupPrntLg'),
);
export const ComboCheckout = lazyWithPreload(() => import('../../pages/WinCombo/ComboCheckout'));
export const JpCheckout = lazyWithPreload(() => import('../../pages/WinCombo/JpCheckout'));
export const ComboUpsell = lazyWithPreload(() => import('../../pages/WinCombo/ComboUpsell'));
export const Success = lazyWithPreload(() => import('../../pages/WinCombo/ComboSuccess'));
export const SuccessPrntLg = lazyWithPreload(
  () => import('../../pages/WinCombo/ComboSuccessPrntLg'),
);
